import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import { ModalContext } from 'App';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import Pagination from 'modules/common/components/Pagination';
import queryString from 'query-string';
import * as action from '../action';
import * as c from '../constant';
import BirthCertificateContent from './BirthCertificateContent';
import CedulaIndividualContent from './CedulaIndividualContent';
import CedulaCorporationContent from './CedulaCorporationContent';
import OccupationalAndHealthContent from './OccupationalAndHealthContent';
import RPTAXContent from './RPTAXContent';
import BTAXContent from './BTAXContent';
import NOVContent from './NOVContent';
import OVRSContent from './OVRSContent';
import DeathCertificateContent from './DeathCertificateContent';
import BPLSContent from './BPLSContent';
import EbossContent from './EbossContent';
import MarriageCertificateContent from './MarriageCertificateContent';

function ModuleTransactionListing({
  // clearTransaction,
  isLoading,
  match,
  transactions,
  getTransactions,
  pager,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const updateData = () => {
    let payload = {};

    if (match.params.transaction_type === 'birth-certificates') {
      payload = {
        module_type: 'PSA',
        transaction_type: 'BIRTH CERTIFICATE',
      };
    }

    if (match.params.transaction_type === 'cedulas') {
      payload = {
        module_type: 'CDL',
      };
    }

    if (match.params.transaction_type === 'occupational-and-healths') {
      payload = {
        module_type: 'OHP',
      };
    }

    if (match.params.transaction_type === 'btax') {
      payload = {
        module_type: 'BTAX',
      };
    }

    if (match.params.transaction_type === 'rptax') {
      payload = {
        permit_type: 'Real Property Tax (RPTAX)',
      };
    }

    if (match.params.transaction_type === 'nov') {
      payload = {
        module_type: 'NOV',
      };
    }

    if (match.params.transaction_type === 'ovrs') {
      payload = {
        module_type: 'OVRS',
      };
    }

    if (match.params.transaction_type === 'bpls') {
      payload = {
        module_type: 'BPLS',
      };
    }

    if (match.params.transaction_type === 't_bpls') {
      payload = {
        module_type: 'T_BPLS',
      };
    }

    if (match.params.transaction_type === 'death-certificates') {
      payload = {
        module_type: 'DC',
        transaction_type: 'DEATH CERTIFICATE',
      };
    }

    if (match.params.transaction_type === 'marriage-certificates') {
      payload = {
        module_type: 'MC',
        transaction_type: 'MARRIAGE CERTIFICATE',
      };
    }

    getTransactions(selectedTransaction, payload);
  };

  const handleChangePage = page => {
    let payload = {};

    if (match.params.transaction_type === 'birth-certificates') {
      payload = {
        module_type: 'PSA',
        transaction_type: 'BIRTH CERTIFICATE',
        page,
      };
    }

    if (match.params.transaction_type === 'cedulas') {
      payload = {
        module_type: 'CDL',
        page,
      };
    }

    if (match.params.transaction_type === 'occupational-and-healths') {
      payload = {
        module_type: 'OHP',
        page,
      };
    }

    if (match.params.transaction_type === 'btax') {
      payload = {
        module_type: 'BTAX',
        page,
      };
    }

    if (match.params.transaction_type === 'rptax') {
      payload = {
        permit_type: 'Real Property Tax (RPTAX)',
        page,
      };
    }

    if (match.params.transaction_type === 'nov') {
      payload = {
        module_type: 'NOV',
        page
      };
    }

    if (match.params.transaction_type === 'ovrs') {
      payload = {
        module_type: 'OVRS',
        page
      };
    }

    if (match.params.transaction_type === 'bpls') {
      payload = {
        module_type: 'BPLS',
        page
      };
    }

    if (match.params.transaction_type === 't_bpls') {
      payload = {
        module_type: 'T_BPLS',
        page
      };
    }

    if (match.params.transaction_type === 'death-certificates') {
      payload = {
        module_type: 'DC',
        transaction_type: 'DEATH CERTIFICATE',
        page,
      };
    }

    if (match.params.transaction_type === 'marriage-certificates') {
      payload = {
        module_type: 'MC',
        transaction_type: 'MARRIAGE CERTIFICATE',
        page,
      };
    }

    getTransactions(selectedTransaction, payload);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [match.params.transaction_type]);

  const viewFullInfo = data => e => {
    e.preventDefault();

    if (match.params.transaction_type === 'birth-certificates') {
      setModal({
        isOpen: true,
        content: (
          <BirthCertificateContent
            taxpayer={_.get(data, 'included.module.attributes')}
            transactionInfo={data}
          />
        ),
        title: 'Birth Certificate Information',
        modalSize: 'modal-xl',
      });
    }

    if (
      match.params.transaction_type === 'cedulas' &&
      _.get(data, 'attributes.transaction_type') === 'INDIVIDUAL'
    ) {
      setModal({
        isOpen: true,
        content: (
          <CedulaIndividualContent
            taxpayer={_.get(data, 'included.module.attributes')}
            transactionInfo={data}
          />
        ),
        title: 'Individual Cedula Information',
        modalSize: 'modal-xl',
      });
    }

    if (
      match.params.transaction_type === 'cedulas' &&
      _.get(data, 'attributes.transaction_type') === 'CORPORATION'
    ) {
      setModal({
        isOpen: true,
        content: (
          <CedulaCorporationContent
            taxpayer={_.get(data, 'included.module.attributes')}
            transactionInfo={data}
          />
        ),
        title: 'Corporation Cedula Information',
        modalSize: 'modal-xl',
      });
    }

    if (match.params.transaction_type === 'occupational-and-healths') {
      setModal({
        isOpen: true,
        content: (
          <OccupationalAndHealthContent
            taxpayer={{
              ..._.get(data, 'included.module.attributes'),
              business_establishments:
                _.get(data, 'included.businessEstablishments') || [],
            }}
            transactionInfo={data}
          />
        ),
        title: 'Occupational & Health Information',
        modalSize: 'modal-xl',
      });
    }

    if (match.params.transaction_type === 'btax') {
      setModal({
        isOpen: true,
        content: (
          <BTAXContent
            taxpayer={{
              ..._.get(data, 'included.module.attributes'),
            }}
            transactionInfo={data}
          />
        ),
        title: 'BTAX Transaction Content',
        modalSize: 'modal-xl',
      });
    }

    if (match.params.transaction_type === 'rptax') {
      setModal({
        isOpen: true,
        content: (
          <RPTAXContent
            taxpayer={{
              ..._.get(data, 'included.module.attributes'),
            }}
            transactionInfo={data}
          />
        ),
        title: 'RPTAX Transaction Content',
        modalSize: 'modal-xl',
      });
    }

    if (match.params.transaction_type === 'nov') {
      setModal({
        isOpen: true,
        content: (
          <NOVContent
            taxpayer={{
              ..._.get(data, 'included.module.attributes'),
            }}
            transactionInfo={data}
          />
        ),
        title: 'Notice of Violation Information',
        modalSize: 'modal-xl',
      });
    }

    if (
      match.params.transaction_type === 'ovrs' &&
      _.get(data, 'attributes.transaction_type') === 'OVR PAYMENT'
    ) {
      setModal({
        isOpen: true,
        content: (
          <OVRSContent
            taxpayer={_.get(data, 'included.module.attributes')}
            transactionInfo={data}
          />
        ),
        title: 'OVRS Information',
        modalSize: 'modal-xl',
      });
    }

    if (match.params.transaction_type === 'bpls') {
      setModal({
        isOpen: true,
        content: (
          <BPLSContent
            taxpayer={_.get(data, 'included.module.attributes')}
            transactionInfo={data}
          />
        ),
        title: 'Business Permit and Licensing System Information',
        modalSize: 'modal-xl',
      });
    }

    if (match.params.transaction_type === 'death-certificates') {
      setModal({
        isOpen: true,
        content: (
          <DeathCertificateContent
            taxpayer={_.get(data, 'included.module.attributes')}
            transactionInfo={data}
          />
        ),
        title: 'Death Certificate Information',
        modalSize: 'modal-xl',
      });
    }

    if (match.params.transaction_type === 't_bpls') {
      setModal({
        isOpen: true,
        content: (
          <EbossContent
            taxpayer={_.get(data, 'included.module.attributes')}
            transactionInfo={data}
          />
        ),
        title: 'E-Boss Information',
        modalSize: 'modal-xl',
      });
    }

    if (match.params.transaction_type === 'marriage-certificates') {
      setModal({
        isOpen: true,
        content: (
          <MarriageCertificateContent
            taxpayer={_.get(data, 'included.module.attributes')}
            transactionInfo={data}
          />
        ),
        title: 'Marriage Certificate Information',
        modalSize: 'modal-xl',
      });
    }
  };

  const renderPermitType = (type, permitTypes) => {
    if (type === 'cedulas') return permitTypes.cdl
    if (type === 'occupational-and-healths') return permitTypes.ohp
    if (type === 'rptax') return permitTypes.rpt
    if (type === 'btax') return permitTypes.btax
    if (type === 'nov') return permitTypes.nov
    if (type === 'birth-certificates') return permitTypes.civilRegistry
    if (type === 'ovrs') return permitTypes.ovrs
    if (type === 'bpls') return permitTypes.bpls
    if (type === 't_bpls') return permitTypes.bpls
    if (type === 'death-certificates') return permitTypes.civilRegistry
    if (type === 'marriage-certificates') return permitTypes.civilRegistry
    return false
  }


  const getReports = () => {
    const path = `${process.env.REACT_APP_WS}/api/v1/administrators/reports/transaction_histories/generate_csv`; // replace API EP once available
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      ...{},
      permit_type: renderPermitType(match.params.transaction_type, c.PERMIT_TYPES_LABELS),
      bearer_token: token,
      email: _.get(authProfile, 'email'),
      tax_payer_id: selectedTransaction,
      transaction_type: match.params.transaction_type === 'birth-certificates' ? 'BIRTH CERTIFICATE' : '',
    });
    return `${path}?${params}`;
  };

  return (
    <>
      <div className="card-section-content container-fluid citizen-tabs">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content mt-0 pt-3 pb-3">
          {/* add button here */}
          {/* {transactions.length > 0 && match.params.transaction_type === 'nov' && ( */}
          {transactions.length > 0 && (
            <div className="d-flex justify-content-end align-items-center mr-3">
              <div className="">
                <a
                  href={getReports()}
                  // className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary  text-white"
                  className="btn btn-md btn-dark text-white"
                // style={{ pointerEvents: 'none', opacity: '0.5' }} // temporary disable while waiting for API EP
                >
                  <i className="fas fa-cloud-download-alt mr-2" />
                  Download
                </a>
              </div>
            </div>
          )}

          {transactions.length > 0 &&
            transactions.map(item => {
              return (
                <React.Fragment key={item.id}>
                  <div
                    className="row highlight d-flex align-items-center mx-1 py-1"
                  >
                    <div className="col-11">
                      <div className="card border-primary">
                        <div className="container-fluid">
                          <TransactionInformation
                            module="citizen"
                            transactionInfo={item}
                          />
                        </div>
                      </div>
                      <div className="col-6 ml-3">
                        <button
                          type="button"
                          className="button btn btn-primary cms-bg-color-primary cms-outline-primary "
                          onClick={viewFullInfo(item)}
                        >
                          <i className="fa fa-external-link-alt" />
                          &nbsp;View
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr className="cit-hr" />
                </React.Fragment>
              );
            })}
          <div className="list-pagination">
            {pager.total_pages > 1 && (
              <div className="d-flex justify-content-center text-center align-item-center">
                <Pagination data={pager} onChange={handleChangePage} />
              </div>
            )}
          </div>
          {transactions.length === 0 && (
            <div className="d-flex align-items-center justitfy-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

ModuleTransactionListing.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  transactions: PropTypes.instanceOf(Array).isRequired,
  // clearTransaction: PropTypes.instanceOf(Function).isRequired,
  getTransactions: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  transactions: _.get(api, `${c.GET_TRANSACTIONS}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_TRANSACTIONS) > -1,
  pager: _.get(api, `${c.GET_TRANSACTIONS}.pager`) || {},
  selectedBirth: _.get(match, 'params.birthId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ModuleTransactionListing);
